// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.master-view-search-wrapper {
  justify-content: flex-start !important;
}

.master-view-batch-table .rdt_TableHead {
  width: 150%;
}
.master-view-batch-table .bMgaAx div:first-child {
  width: 150%;
  white-space: normal;
}
.master-view-batch-table .rdt_TableBody {
  width: 150%;
  align-items: center;
}

.circle {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/invoices/style.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;AACF;;AAGE;EACI,WAAA;AAAN;AAGE;EACI,WAAA;EACA,mBAAA;AADN;AAIE;EACI,WAAA;EACA,mBAAA;AAFN;;AAMA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAHF","sourcesContent":[".master-view-search-wrapper{\n  justify-content: flex-start !important;\n}\n\n.master-view-batch-table{\n  .rdt_TableHead {\n      width: 150%;\n  }\n\n  .bMgaAx div:first-child {\n      width: 150%;\n      white-space: normal;\n  }\n\n  .rdt_TableBody{\n      width: 150%;\n      align-items: center;\n  }\n}\n\n.circle {\n  display: inline-block;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  // background-color: #00FF00;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
